import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const Ciudad = {

    async Get() {  return await methods.Get("Ciudad/Get" ); },
    async Post(data) { return await methods.Post("Ciudad/Post", data) },
    async Put(qs, data) { return await methods.Put("Ciudad/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("Ciudad/Delete" + useParamsJson(qs)) }
};

export default Ciudad;